import type { NavGroup, NavItem } from "@/types/global";

export const mainNav: NavGroup[] = [
  {
    label: "Služby",
    href: "/sluzby",
    items: [
      { label: "Účetnictví", href: "/sluzby/ucetnictvi" },
      { label: "Daňové poradenství", href: "/sluzby/danove-poradenstvi" },
      { label: "Zpracování mezd", href: "/sluzby/zpracovani-mezd" },
      { label: "Přehled služeb", href: "/sluzby" },
    ],
  },
  { label: "O firmě", href: "/o-firme" },
  { label: "Poradna", href: "/poradna" },
  { label: "Dokumenty", href: "/dokumenty-ke-stazeni" },
];

export const footerServiceLinks: NavItem[] = [
  { label: "Účetnictví", href: "/sluzby/ucetnictvi" },
  { label: "Daňové poradenství", href: "/sluzby/danove-poradenstvi" },
  { label: "Zpracování mezd", href: "/sluzby/zpracovani-mezd" },
  { label: "Přehled služeb", href: "/sluzby" },
];

export const footerCompanyLinks: NavItem[] = [
  { label: "O firmě", href: "/o-firme" },
  { label: "Poradna", href: "/poradna" },
  { label: "Dokumenty a certifikáty", href: "/dokumenty-ke-stazeni" },
  { label: "Užitečné odkazy", href: "/uzitecne-odkazy" },
];

export const footerContactLinks: NavItem[] = [
  { label: "Kontakt", href: "/kontakt" },
  { label: "Ochrana osobních údajů", href: "/ochrana-osobnich-udaju" },
];

export const serviceSubNav = [
  { id: "prinos", label: "Přínos pro klienta" },
  { id: "pro-koho", label: "Pro koho je služba vhodná" },
  { id: "rozsah", label: "Rozsah činností" },
  { id: "prubeh", label: "Průběh spolupráce" },
  { id: "podklady", label: "Co potřebujeme od vás" },
  { id: "faq", label: "Časté dotazy" },
] as const;
